import { useState } from 'react';
import { useSelector } from 'react-redux';
import { isEmpty, isEqual, xorWith } from 'lodash';
import { User } from 'types/project';
import { getProject } from '../../features/project/projectSlice';
import userTokenService from '../services/security/userTokenService';
import useCustomCompareEffect from './useCustomCompareEffect';

type ReturnType = User | undefined;

export const useGetCurrentUser = (): ReturnType => {
  const project = useSelector(getProject);
  const [currentUser, setCurrentUser] = useState<User>();

  useCustomCompareEffect(
    () => {
      let isMounted = true;
      async function getUser() {
        if (project.id) {
          const userEmail = (await userTokenService.getProjectTokenProperty(
            project.id,
            'email'
          )) as string;
          if (isMounted) {
            setCurrentUser(
              project?.users?.find(
                (user) => user.email.toLowerCase() === userEmail.toLowerCase()
              )
            );
          }
        }
      }
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      getUser();
      return () => {
        isMounted = false;
      };
    },
    [project.id, project.users],
    (a, b) => {
      if (Array.isArray(a)) {
        return isEmpty(xorWith(a, b, isEqual));
      }
      return a === b;
    }
  );

  return currentUser;
};
